// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';

import { Card, CardHeader, CardContent, Divider } from '@mui/material';

type Props = {
  title?: string;
  children: any | any[];
  codeModel?: any | any[];
  height?: string;
};

const ChildCard = ({ title, children, codeModel, height }: Props) => (
  <Card sx={{ padding: 0, borderColor: (theme: any) => theme.palette.divider, height: height ? height : 'auto' }} variant="outlined">
    {title ? (
      <>
        <CardHeader title={title} action={codeModel} />
        <Divider />{' '}
      </>
    ) : (
      ''
    )}

    <CardContent>{children}</CardContent>
  </Card>
);

export default ChildCard;
